export const TYPE = 'type';
export const TYPE_NAME = 'name';
export const PERIODS = 'periods';
export const PERIOD = 'period';
export const PERIOD_START_DATE = 'startDate';
export const PERIOD_END_DATE = 'endDate';
export const RATE = 'rate';
export const RATE_VALUE = 'value';
export const RATE_CURRENCY = 'currency';
export const FINANCIAL_RESULT_ID = 'financialResultId';
export const IS_FINISH_DATE_REQUIRED = 'isFinishDateRequired';
export const IS_FUTURE_COST_MODEL = 'isFutureCostModel';
export const IS_UNRESTRICTED_DATES = 'isUnrestrictedDates';
export const IS_SUPPORT_ACTIVITY_TYPES = 'supportsActivityTypes';
export const CUSTOM_FLAT_FEE_ID = 10;
export const IS_REMOVABLE = 'isRemovable';
export const IS_READONLY = 'isReadonly';
export const TYPE_ID = 'id';
export const CURRENCY_USD = 'usd';
export const PENDING_CHANGES = 'pendingChanges';
export const EVENT = 'subType';
export const CPE_ID = 1000;
export const CAMPAIGN_TYPE = 'type';
export const CAMPAIGN_TYPE_ID = 'id';
export const ACTIVITY_TYPE = 'activityType';

export const ACTIVITY_TYPE_UA = 0;
export const ACTIVITY_TYPE_RE = 1;
export const ACTIVITY_TYPE_TOTAL = 2;

export const DEFAULT_ACTIVITY_TYPE = 'defaultActivityType';

export const getIndicatorColor = (typeId) => {
  switch (typeId) {
    case ACTIVITY_TYPE_UA:
      return 'info';
    case ACTIVITY_TYPE_RE:
      return 'pending';
    case ACTIVITY_TYPE_TOTAL:
      return 'draft';
    default:
      return 'inactive';
  }
};
